window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// jQuery is loaded from CDN (see footer-scripts.blade.php)
// require("jquery") resolves to window.jQuery via webpack externals
var $ = require("jquery");
window.Popper = require("popper.js").default;
window.selectpicker = require("bootstrap-select");

require("bootstrap");

// DataTables is loaded via CDN script tags in the layout (see footer-scripts.blade.php)
// This ensures reliable initialization since jQuery plugins attach directly to window.jQuery

// Custom modules - load independently so one failure doesn't break others
try {
    require("./navigation");
} catch (e) {
    console.error("Navigation module failed:", e);
}

try {
    require("./forms");
} catch (e) {
    console.error("Forms module failed:", e);
}

try {
    require("./charts");
} catch (e) {
    console.error("Charts module failed:", e);
}

try {
    require("./datatables");
} catch (e) {
    console.error("DataTables custom module failed:", e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Configure Axios to send the CSRF token from the meta tag if present,
// otherwise fall back to Laravel's default XSRF cookie header behavior
const csrfTokenMeta = document.head.querySelector('meta[name="csrf-token"]');
if (csrfTokenMeta) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] =
        csrfTokenMeta.content;
}
window.axios.defaults.xsrfCookieName = "XSRF-TOKEN";
window.axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

// Enable pusher logging - don't include this in production
// window.Pusher.logToConsole = true;
